import * as angular from 'angular';
import * as moment from 'moment';

/* global malarkey:false, moment:false */
(function () {
    'use strict';

    angular.module('app').constant('moment', moment);
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/index.constants.ts